import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import {
  SET_DATA_KEY,
  WORKOUT_EXERCISE_KEY
} from '../../../../workout-exercise/model/constants'
import sortByArrayUtil from 'packages/src/modules/array/sort-by'

function getRoundsWorkoutSectionUtil (workoutExercises) {
  const rounds = []
  workoutExercises = sortByArrayUtil(workoutExercises, (workoutExercise, index) => {
    return (
      getValueReduxUtil(workoutExercise, WORKOUT_EXERCISE_KEY.ORDER) || index
    )
  })

  workoutExercises.forEach((workoutExercise, index) => {
    const setData = getValueReduxUtil(workoutExercise,
      WORKOUT_EXERCISE_KEY.SET_DATA
    )

    const id = getIdReduxUtil(workoutExercise)
    const exerciseId = getValueReduxUtil(
      workoutExercise,
      WORKOUT_EXERCISE_KEY.EXERCISE_ID
    )
    let previousRoundIndex = 0
    setData.forEach((set, i) => {
      let roundIndex
      const roundObj = {
        set,
        setIndex: i
      }
      if (set[SET_DATA_KEY.REST] != null) {
        // If it's a rest, use the previous round index used
        // for the normal set, then increase the previous index
        roundIndex = previousRoundIndex
        previousRoundIndex += 1
      } else {
        // If it's a set, add it to the round
        if (!previousRoundIndex) {
          roundIndex = 0
        } else {
          roundIndex = previousRoundIndex
        }
        // If this exercise has no rest, increase the previous index
        const nextSet = setData[i + 1]
        if (nextSet && nextSet[SET_DATA_KEY.REST] == null) {
          previousRoundIndex += 1
        }
      }

      const round = rounds[roundIndex]
      if (!round) {
        // Create the round at the current round index if necessary
        rounds[roundIndex] = []
      }

      rounds[roundIndex].push({
        ...roundObj,
        workoutExerciseId: id,
        exerciseId,
        workoutExerciseOrder: getValueReduxUtil(
          workoutExercise,
          WORKOUT_EXERCISE_KEY.ORDER
        ),
        workoutExerciseIndex: index
      })
    })
  })

  return rounds
}

export default getRoundsWorkoutSectionUtil
